/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./ContentCapabilitiesAPI'
], (APIFactory, ContentCapabilitiesAPI) => {
	/**
	 * @class ContentCapabilities
	 * @implements ContentCapabilitiesAPI
	 * @classdesc class that is used to register capabilities of a content
	 */
	class ContentCapabilities {
		constructor({ options }) {
			this._api = APIFactory.createAPI(this, [ContentCapabilitiesAPI]);
			this._options = options || {};
		}

		getAPI() {
			return this._api;
		}

		getCapabilities() {
			return Object.assign({
				'selection': false,
				'title': false,
				'move': false,
				'resize': false,
				'rotation': false
			}, this._options);
		}
	}

	return ContentCapabilities;
});